import { Component, OnInit,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-deletePopup',
  templateUrl: './deletePopup.component.html',
  styleUrls: ['./deletePopup.component.css']
})
export class DeletePopupComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<DeletePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onYesClick() {
    this.dialogRef.close('yes');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/deletePopup/deletePopup.component.ts